{
	"VALIDATION_FAILED": "Request validation failed. Check the highlighted fields.",
	"INVALID_CREDENTIALS": "Invalid username/email or password.",
	"ACCOUNT_INACTIVE": "This account is not active. An administrator has to re-enable it.",
	"NO_ROLES_ASSIGNED": "Your account has no roles yet. Ask an administrator to assign one.",
	"TOKEN_MISSING": "Authorization token required.",
	"TOKEN_INVALID": "Invalid token.",
	"TOKEN_EXPIRED": "Access token expired.",
	"SESSION_EXPIRED": "Your session has expired. Please sign in again.",
	"SESSION_REVOKED": "Your session was ended. Please sign in again.",
	"REFRESH_REUSE_DETECTED": "You have been signed out for security reasons.",
	"ROLE_NOT_HELD": "You do not hold that role.",
	"FORBIDDEN_ROLE": "Your active role does not permit this action.",
	"FORBIDDEN_SCOPE": "This record is outside your assigned scope.",
	"PASSWORD_CHANGE_REQUIRED": "You must change your password before continuing.",
	"MFA_REQUIRED": "Two-factor authentication is required for this role. Please sign in again.",
	"MFA_ENROLLMENT_REQUIRED": "Two-factor authentication must be set up before continuing.",
	"MFA_INVALID_CODE": "That code didn't work. Codes change every 30 seconds — try the current one.",
	"MFA_ALREADY_ENABLED": "Two-factor authentication is already enabled. Ask an administrator to reset it.",
	"MFA_NOT_ENABLED": "Two-factor authentication is not enabled on this account.",
	"MFA_TICKET_INVALID": "That took too long. Enter your password again to restart sign-in.",
	"CANNOT_MANAGE_HIGHER_ROLE": "You cannot manage a user with a higher role than your own.",
	"CANNOT_GRANT_HIGHER_ROLE": "You cannot grant a role higher than your own.",
	"CANNOT_TARGET_SELF": "Your own account can't be part of this action. Deselect it and try again.",
	"CONFIRMATION_PASSWORD_INVALID": "That is not your password. Enter your own password to confirm this action.",
	"NOT_FOUND": "That record was not found. It may have been removed.",
	"CONFLICT": "That value is already in use.",
	"STALE_VERSION": "Someone else changed this record while you had it open. Reload it and try again.",
	"NOT_SHORTLISTED": "Only athletes shortlisted for this event in the GMS can be entered.",
	"USERNAME_TAKEN": "That username is already taken.",
	"EMAIL_TAKEN": "That email is already in use.",
	"RATE_LIMITED": "Too many attempts. Please try again later.",
	"SERVICE_UNAVAILABLE": "Can't reach the server. This is a connection problem, not your password — wait a moment and try again.",
	"NETWORK": "No connection to the server. Your edits are kept on this device and will be sent when the connection is back.",
	"INTERNAL_ERROR": "Something broke on our side. If it keeps happening, send the request ID below.",
	"RATE_LIMITED_noRetry": "Too many attempts. Wait a few minutes, or ask an administrator to unlock your account.",
	"RATE_LIMITED_waitSeconds_one": "Too many attempts. Try again in {{count}} second, or ask an administrator to unlock your account.",
	"RATE_LIMITED_waitSeconds_other": "Too many attempts. Try again in {{count}} seconds, or ask an administrator to unlock your account.",
	"RATE_LIMITED_waitMinutes_one": "Too many attempts. Try again in {{count}} minute, or ask an administrator to unlock your account.",
	"RATE_LIMITED_waitMinutes_other": "Too many attempts. Try again in {{count}} minutes, or ask an administrator to unlock your account.",
	"GENERIC": "Something went wrong."
}
